export default __webpack_public_path__ + "static/media/appointmentMob.96d7c441.png";